import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5l6 0","key":"svg-0"}],["path",{"d":"M7 19l6 0","key":"svg-1"}],["path",{"d":"M14 5l-4 14","key":"svg-2"}]]

const IconItalic = createReactComponent('outline', 'italic', 'Italic', __iconNode);

export default IconItalic;